<template>
  <router-view></router-view>
</template>

<style lang="scss">
@import url('@/assets/iconfonts/general/iconfont.css');
</style>
